export default "__VITE_ASSET__oWNMfjr0__"